import { Auth } from 'aws-amplify'

const refreshSession = async () => {
	const session = await Auth.currentSession()
	const user = await Auth.currentAuthenticatedUser({ bypassCache: true })

	return new Promise((resolve, reject) => {
		// have to use it as no type can be located or inferred
		// eslint-disable-next-line
		user.refreshSession(session.getRefreshToken(), async (err: any, session: any) => {
			if (err) {
				reject(err)
			} else {
				try {
					// Fetch latest user attributes from Cognito
					const attributes = await Auth.userAttributes(user)
					resolve({
						session: session,
						attributes,
					})
				} catch (attrErr) {
					reject(attrErr)
				}
			}
		})
	})
}

export { refreshSession }
